import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "card p-3 position-relative" }
const _hoisted_4 = { class: "row m-0" }
const _hoisted_5 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-success d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-3x text-success" })
], -1)
const _hoisted_8 = { class: "col mt-5" }
const _hoisted_9 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-danger d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3x text-danger" })
], -1)
const _hoisted_12 = { class: "col mt-5 ml-1" }
const _hoisted_13 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-success d-flex align-items-center px-6 py-8 rounded-2" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_16 = { class: "col mt-5" }
const _hoisted_17 = { class: "col-md-3 col-6 border border-5 border-white-and-rounded bg-light-info px-6 py-8 rounded-2" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-info d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock fs-3x text-info" })
], -1)
const _hoisted_20 = { class: "col mt-5" }
const _hoisted_21 = { class: "card mt-5" }
const _hoisted_22 = { class: "card-body p-0" }
const _hoisted_23 = { class: "card p-3 position-relative" }
const _hoisted_24 = { class: "row m-0" }
const _hoisted_25 = { class: "col bg-light-info px-6 py-8 rounded-2" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-info d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock fs-3x text-info" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h4", { class: "col mt-5" }, "0", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.data.total_assessor), 1),
                _createVNode(_component_router_link, {
                  to: "/course/search-course",
                  class: "text-success fw-bold fs-6 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Course")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.data.total_trainers), 1),
                _createVNode(_component_router_link, {
                  to: "/trainer/trainer-list",
                  class: "text-danger fw-bold fs-6 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Trainers")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.data.total_assessor), 1),
                _createVNode(_component_router_link, {
                  to: "/assessor/assessor-list",
                  class: "text-success fw-bold fs-6 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Assessors")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.data.total_assessor), 1),
                _createVNode(_component_router_link, {
                  to: "/course-batch/search",
                  class: "text-info fw-bold fs-7 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("ATTENDANCE PENDING (BATCH COUNT)")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _hoisted_28,
                _createVNode(_component_router_link, {
                  to: "/bill-list",
                  class: "text-info fw-bold fs-6 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Pending Bill")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}